import { memo } from 'react';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { FolderRow } from './folderRow/FolderRow';

import css from './FileSystemTable.module.css';

import { FolderModel } from 'v2/types/FileSystemModel';

interface FileSystemTableProps {
  folders: FolderModel[];
}

export const FileSystemTable = memo<FileSystemTableProps>(({ folders }) => (
  <TableContainer className={css.fileSystemTableContainer}>
    <Table stickyHeader size="small">
      <TableHead>
        <TableRow>
          <TableCell style={{ width: '40%' }} className={css.fileSystemTableHead}>
            Name
          </TableCell>

          <TableCell style={{ width: '20%' }} className={css.fileSystemTableHead} align="right">
            Created
          </TableCell>

          <TableCell style={{ width: '20%' }} className={css.fileSystemTableHead} align="right">
            Updated
          </TableCell>

          <TableCell style={{ width: '20%' }} className={css.fileSystemTableHead} align="right" />
        </TableRow>
      </TableHead>

      <TableBody>
        {folders.map((folder) => (
          <FolderRow key={folder.id} folder={folder} depth={0} />
        ))}
      </TableBody>
    </Table>
  </TableContainer>
));

FileSystemTable.displayName = 'FileSystemTable';
